import ApiService from "./ApiService";

export async function apiGetAllOrderId(data) {
    return ApiService.fetchData({
      url: "/po/all",
      method: "get",
      data,
    });
  }

  export async function apiGetAllrawMaterial(data) {
    return ApiService.fetchData({
      url: "/stock/all",
      method: "get",
      data,
    });
  }

  export async function apiPostBom(data) {
    return ApiService.fetchData({
      url: "/bom/register",
      method: "post",
      data,
    });
  }
  export async function apiGetallBom(data) {
    return ApiService.fetchData({
      url: "/bom",
      method: "post",
      data,
    });
  }
  export async function apiDeleteBom(data) {
    return ApiService.fetchData({
      url: "/bom/delete/id",
      method: "delete",
      data,
    });
  }
  export async function apiUpdateBom(data) {
    return ApiService.fetchData({
      url: "/bom/update/id",
      method: "put",
      data,
    });
  }
  export async function apiGetBomDetails(data) {
    return ApiService.fetchData({
      url: "/bom/id",
      method: "post",
      data,
    });
  }


  
 
